import React, { useEffect, useState } from "react";
import { Backdrop, Box } from "@mui/material";
import StatsCards from "../Cards/StatsCards";
import { useParams } from "react-router-dom";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";

import ParticipantCreationOverTime from "../Insights/ParticipantCreationOverTime";
import Loader from "../../Common/assets/Loader";
import {
  CardTypes,
  DashboardCards,
  // formatFunnelPieData,
  formatGroupPieData,
  formatParticipantGraph,
  formatTableData,
} from "./dashboard";
import TotalPeopleAcrossGroupPie from "../Insights/TotalPeopleAcrossGroupPie";
// import ParticipantFunnelPie from "../Insights/ParticipantFunnelPie";
import GroupRecruitmentChart from "../Insights/GroupRecruitmentChart";
import GroupRecruitmentTable from "../Insights/GroupRecruitmentTable";

const DashboardContentV2 = () => {
  const { id: studyId } = useParams();
  const [loading, setLoading] = useState(true);
  const [cardData, setCardData] = useState<any>(null);
  const [lineGraphData, setLineGraphData] = useState<any>({});
  const [groupPieData, setGroupPieData] = useState<any>({});
  // const [funnelPieData, setFunnelPieData] = useState<any>({});
  const [groupRecruitmentData, setGroupRecruitmentData] = useState<any>([]);
  const [groupRecruitmentTableData, setGroupRecruitmentTableData] =
    useState<any>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res: AxiosResponse = await http.get(
          `/study/${studyId}/dashboard/general-admin`
        );
        const apiRes = res.data.data;
        const cardData = DashboardCards.map((card: any) => {
          return {
            ...card,
            value: apiRes?.counts?.[card.key] || 0,
          };
        }).filter((item: any) => CardTypes.includes(item.key));

        setCardData(cardData);
        const newlineData = formatParticipantGraph(
          apiRes?.participant_creations_month_wise
        );

        setLineGraphData({
          data: newlineData,
          title: "Participant Creation Over Time",
        });

        const formattedGroupPieData = formatGroupPieData(
          apiRes?.participant_groups
        );
        setGroupPieData(formattedGroupPieData);

        // const formmatedFunnelPieData = formatFunnelPieData(
        //   apiRes?.participant_groups
        // );
        // setFunnelPieData(formmatedFunnelPieData);

        setGroupRecruitmentData({
          data: apiRes?.participant_groups,
          title: "Group Recruitment Summary (total)",
        });

        const formattedNewTableData = formatTableData(
          apiRes?.participant_groups
        );

        setGroupRecruitmentTableData({
          data: formattedNewTableData,
          title: "Group Recruitment Data",
        });

        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchData();
  }, [studyId]);

  return (
    <>
      {loading ? (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      ) : (
        <>
          <Box
            sx={{ display: "flex", gap: 2, alignItems: "flex-start", mb: 2 }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                gridGap: "16px",
                width: "100%",
              }}
            >
              {cardData?.map((item: any) => (
                <Box key={item?.key}>
                  <StatsCards data={item} />
                </Box>
              ))}
            </Box>
          </Box>

          <Box mb={2}>
            <ParticipantCreationOverTime data={lineGraphData} />
          </Box>
          <Box
            sx={{
              // display: "grid",
              // gridTemplateColumns: "repeat(auto-fill, minmax(532px, 1fr))",
              // gridTemplateRows: "repeat(auto-fill, minmax(auto, 1fr))",
              // gridGap: "16px",
              mb: 2,
            }}
          >
            <TotalPeopleAcrossGroupPie data={groupPieData} />
            {/* <ParticipantFunnelPie data={funnelPieData} /> */}
          </Box>
          <Box mb={2}>
            <GroupRecruitmentTable data={groupRecruitmentTableData} />
          </Box>
          <Box mb={2}>
            <GroupRecruitmentChart data={groupRecruitmentData} />
          </Box>
        </>
      )}
    </>
  );
};

export default DashboardContentV2;
